const GLOBAL_TABLES = new Set([
  "diagnosis_codes",
  "disorders",
  "medications",
  "treatment_types",
  "treatment_status",
  "treatment_status_reasons",
  "treatment_programs",
  "tms_protocols",
  "tms_devices",
  "tms_coils",
  "tms_frequencies",
  "tms_pulse_types",
  "tms_stimulation_sites",
  "procedure_codes",
  "procedure_categories",
  "providers",
  "ai_providers",
  "security_groups",
  "security_group_menus",
  "menu_components",
  "menu_items",
  "menus",
  "model_catalog",
  "model_versions",
  "ui_card_types",
  "ui_summary_types",
  "biomarker_types",
  "biomarkers",
  "practices",
  "questionnaires",
  "questionnaire_criteria",
  "questionnaire_score_intervals",
  "questionnaire_score_indications",
  "populations",
]);

export function isPracticeScopedTable(table) {
  return !GLOBAL_TABLES.has(table);
}
